import type { Movimiento } from "../api/tipos.ts";
import type { Decision } from "../ganchos/datos.ts";
import { atajoDe, cargaDeAtajo } from "./atajo-de-pago.ts";

/**
 * La mesa de conciliación (SPEC-029 §14): para quien limpia cien casos en un
 * día —en Lorus, 113 etiquetas el 29 de septiembre, una por una—.
 */

/**
 * Lo que se puede confirmar en lote: exactamente lo que tiene el «sí» de un
 * clic en su fila. Si algo comprobable está en contra, o falta elegir la
 * factura, no entra (P-4): el lote no es una forma de saltarse la regla.
 */
export function cargaDeLote(m: Movimiento): Decision | null {
  return cargaDeAtajo(m, atajoDe(m));
}

export const seleccionables = (pendientes: Movimiento[]) => pendientes.filter((m) => cargaDeLote(m) !== null);

export type Tecla = "siguiente" | "anterior" | "abrir" | "si" | "no" | "marcar";

/**
 * Los atajos de teclado. j/k o las flechas para moverse, Enter o «o» para
 * abrir, «s» para el sí de la fila, «n» para «no es de este cliente», «x»
 * para marcar en el lote.
 */
export function teclaDe(e: { key: string; ctrlKey?: boolean; metaKey?: boolean; altKey?: boolean }): Tecla | null {
  if (e.ctrlKey || e.metaKey || e.altKey) return null;
  switch (e.key) {
    case "j":
    case "ArrowDown":
      return "siguiente";
    case "k":
    case "ArrowUp":
      return "anterior";
    case "Enter":
    case "o":
      return "abrir";
    case "s":
      return "si";
    case "n":
      return "no";
    case "x":
      return "marcar";
    default:
      return null;
  }
}

/** ¿El foco está en algo donde se escribe? Entonces las teclas son del texto. */
export const escribiendo = (el: Element | null) =>
  !!el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT" || (el as HTMLElement).isContentEditable);
